import { useTranslation } from 'react-i18next';
import { Page } from '@web/components/page';
import { SellingACatScreen, SellingACatScreenProps } from 'shared/screens/selling-a-cat';
import { withServerProps } from '@web/library/with-server-props';

export default function SellingACat(props: SellingACatScreenProps) {
  const { t } = useTranslation('screens');

  return (
    <Page
      {...props}
      register={(seo) => seo.forPage(t('selling_a_cat.title'), t('selling_a_cat.description'))}
    >
      <SellingACatScreen {...props} />
    </Page>
  );
}

export const getServerSideProps = withServerProps(SellingACatScreen.pageBuilder);
